// Supporting findings, derived from the graph's own frameworks and action plan.
// These are secondary to the representative cards and map each obligation to the
// exact GDPRLocal service the graph already points to.

const SERVICE_FALLBACK = {
  "GDPR Consultancy": "https://gdprlocal.com/gdpr-consultant/",
  Consultancy: "https://gdprlocal.com/gdpr-consultant/",
  "Fractional DPO": "https://gdprlocal.com/gdpr-data-protection-officer/",
  "AI and Data Protection Training": "https://gdprlocal.com/ai-and-data-protection-compliance-training/",
  "Compliance Hub": "https://gdprlocal.com/pricing/",
};

export function supportingFindings(facts) {
  if (!facts) return [];
  const out = [];
  const clean = (s) => (typeof s === "string" ? s.replace(/\u2014/g, ", ").replace(/\s+,/g, ",") : s);

  if (facts.special_category) {
    out.push({
      id: "special-category",
      title: "Special category data handling",
      framework: "GDPR Article 9",
      why: "You appear to process special category data (for example health information). That carries heightened obligations around lawful basis, security, and data protection impact assessments.",
      serviceLabel: "GDPR Consultancy",
      serviceUrl: SERVICE_FALLBACK["GDPR Consultancy"],
      source: facts.special_category_source || null,
    });
  }

  (facts.action_plan || []).forEach((a, i) => {
    if (!a || !a.title) return;
    const url = a.service_url || SERVICE_FALLBACK[a.service_label] || null;
    out.push({
      id: `ap-${i}`,
      title: clean(a.title),
      framework: clean(a.framework),
      why: clean(a.rationale),
      priority: a.priority,
      serviceLabel: a.service_label,
      serviceUrl: url,
      source: a.source || null,
    });
  });

  return out;
}

export function applicableFrameworks(facts) {
  if (!facts || !Array.isArray(facts.frameworks)) return [];
  return facts.frameworks.filter((f) => f.applicable && f.name).map((f) => f.name);
}

// All frameworks as scannable chips: applicable ones first, each with its source.
// Assumptions (the visitor's confirmed corrections) override the graph baseline
// so a correction like "we are also in Switzerland" flips the relevant chip live.
export function frameworkChips(facts, assumptions) {
  if (!facts || !Array.isArray(facts.frameworks)) return [];
  const clean = (s) => (typeof s === "string" ? s.replace(/\u2014/g, ", ").replace(/\s+,/g, ",") : s);
  const a = assumptions || {};
  const override = (name) => {
    const n = String(name || "").toLowerCase();
    if (n.includes("eu gdpr")) return a.eu_residents;
    if (n.includes("uk gdpr")) return a.uk_residents;
    if (n.includes("fadp") || n.includes("swiss")) return a.swiss_residents;
    if (n.includes("ai act")) return a.uses_ai;
    return undefined;
  };
  return facts.frameworks
    .filter((f) => f && f.name)
    .map((f) => {
      const ov = override(f.name);
      const graphApplicable = !!f.applicable;
      const applicable = ov === undefined ? graphApplicable : !!ov;
      const corrected = ov !== undefined && !!ov !== graphApplicable;
      let rationale = clean(f.rationale);
      if (corrected) {
        rationale = applicable
          ? "You told us this now applies to your situation, so we have brought it into scope."
          : "You told us this does not apply to your situation, so we have taken it out of scope.";
      }
      return { name: clean(f.name), applicable, rationale, source: corrected ? null : f.source || null, corrected };
    })
    .sort((a, b) => (a.applicable === b.applicable ? 0 : a.applicable ? -1 : 1));
}
